import React from 'react';
import { Box, HStack, Link, Text, Tooltip } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { seloDaCorrida } from './texto';

/**
 * Selo da corrida Lalamove no card da compra (#2307): status, custo e o link
 * de rastreio. Clicar abre a corrida (acompanhar, cancelar, tirar o pedido).
 * Fica distinto do frete do fornecedor, que o card ja mostra.
 */
export default function SeloCorrida({ corrida, onAbrir }) {
    const selo = seloDaCorrida(corrida);
    if (!selo) return null;

    const outras = (corrida.compras_na_corrida || 1) - 1;

    return (
        <Box
            role="button"
            tabIndex={0}
            cursor="pointer"
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); if (onAbrir) onAbrir(); }
            }}
            w="100%"
            textAlign="left"
            bg={`${selo.cor}.50`}
            borderWidth="1px"
            borderColor={`${selo.cor}.200`}
            borderRadius="md"
            px={2}
            py={1}
            mb={2}
            transition="all 0.15s"
            _hover={{ borderColor: `${selo.cor}.400`, shadow: 'xs' }}
            onClick={(e) => { e.stopPropagation(); if (onAbrir) onAbrir(); }}
            aria-label={`Ver corrida Lalamove: ${corrida.status_rotulo}`}
        >
            <HStack justify="space-between" spacing={2}>
                <Text fontSize="11px" fontWeight="bold" color={`${selo.cor}.800`} noOfLines={1}>{selo.texto}</Text>
                {selo.custo && <Text fontSize="11px" fontWeight="bold" color={`${selo.cor}.800`} flexShrink={0}>{selo.custo}</Text>}
            </HStack>
            <HStack justify="space-between" spacing={2}>
                <Text fontSize="10px" color="gray.600" noOfLines={1}>
                    {corrida.modalidade || 'Lalamove'}
                    {corrida.numero_pedido ? ` · ped. ${corrida.numero_pedido}` : ''}
                    {outras > 0 ? ` · +${outras} pedido(s)` : ''}
                </Text>
                {corrida.share_link && !selo.encerradaSemColeta && (
                    <Tooltip label="Acompanhar ao vivo" hasArrow>
                        <Link href={corrida.share_link} isExternal fontSize="10px" color={`${selo.cor}.700`} fontWeight="bold"
                            onClick={(e) => e.stopPropagation()} flexShrink={0}>
                            rastrear <ExternalLinkIcon boxSize={2.5} />
                        </Link>
                    </Tooltip>
                )}
            </HStack>
        </Box>
    );
}
